import * as React from "react";
import { useTranslation } from "react-i18next";
import { Loader2 } from "lucide-react";
import { Button } from "@/app/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/app/components/ui/dialog";
import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/app/components/ui/alert-dialog";

export function DismissRequestDialog({
  id,
  onClose,
  onSubmit,
  isPending,
}: {
  id: string | null;
  onClose: () => void;
  onSubmit: () => Promise<void>;
  isPending: boolean;
}) {
  const { t } = useTranslation();
  return (
    <Dialog open={id !== null} onOpenChange={(o) => !o && onClose()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t("dialog.dismissRequest.title")}</DialogTitle>
          <DialogDescription>{t("dialog.dismissRequest.description")}</DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" onClick={onClose} disabled={isPending}>
            {t("dialog.common.cancel")}
          </Button>
          <Button onClick={() => onSubmit()} disabled={isPending}>
            {isPending && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
            {t("dialog.dismissRequest.confirm")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

export function RevokeCoreDialog({
  id,
  onClose,
  onConfirm,
  isPending,
}: {
  id: string | null;
  onClose: () => void;
  onConfirm: () => Promise<void>;
  isPending: boolean;
}) {
  const { t } = useTranslation();
  return (
    <AlertDialog open={id !== null} onOpenChange={(o) => !o && onClose()}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{t("dialog.revokeCore.title")}</AlertDialogTitle>
          <AlertDialogDescription>{t("dialog.revokeCore.description")}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isPending}>
            {t("dialog.common.cancel")}
          </AlertDialogCancel>
          <AlertDialogCancel
            disabled={isPending}
            onClick={onConfirm}
            className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
          >
            {isPending && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
            {t("dialog.revokeCore.confirm")}
          </AlertDialogCancel>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
